/**
 * Waits until a condition is met and then executes a function, with a timeout mechanism.
 *
 * @template T The return type of the function to be executed
 * @param {() => boolean} isReady A function that checks if the condition is met
 * @param {() => T} fn The function to execute when the condition is met
 * @param {number} delay Time to wait between checks (in milliseconds)
 * @param {number} max Maximum total waiting time (in milliseconds)
 * @param {number} [currentTime=0] Current elapsed time
 * @returns {Promise<T | void>} Result of the function or undefined if timeout occurs
 * @throws {Error} If the function execution fails
 * @example
 * // Wait until a DOM element exists, then do something
 * await waitUntil(
 *   () => document.querySelector('#myElement') !== null,
 *   () => document.querySelector('#myElement').textContent,
 *   100,
 *   5000
 * );
 */
export const waitUntil = async <T>(
  isReady: () => boolean,
  fn: () => T,
  delay: number,
  max: number,
  currentTime = 0
): Promise<T | void> => {
  if (currentTime > max) return
  if (isReady()) return fn()
  await sleep(delay)
  return waitUntil(isReady, fn, delay, max, currentTime + delay)
}

// export const waitUntil = async <T>(
//   isReady: () => boolean,
//   fn: () => T,
//   delay: number,
//   max: number
// ): Promise<T | void> =>
//   new Promise(resolve => {
//     const interval = setInterval(() => {
//       if (!isReady()) return
//       clearInterval(interval)
//       const res = fn()
//       resolve(res)
//     }, delay)

//     setTimeout(() => {
//       clearInterval(interval)
//       resolve()
//     }, max)
//   })
